var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55834 8.00004C6.51861 8.00876 5.47864 8.00685 4.43882 8.00107C4.14502 7.99933 3.99947 8.10075 4 8.43514C4.00651 12.1638 4.00398 15.8924 4.00475 19.621C4.00483 19.763 3.98308 19.919 4.15789 19.9836C4.16455 20.0064 7.83017 20.0049 7.84004 19.9824C8.033 19.9072 7.9941 19.7323 7.99418 19.5811C7.99586 15.8787 7.99288 12.1763 8 8.47397C8.00053 8.13799 7.88553 7.99727 7.55834 8.00004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99997 3C4.89547 3 4 3.89547 4 4.99997C4 6.1046 4.89547 7 5.99997 7C7.10453 7 8 6.1046 8 4.99997C8 3.89547 7.10453 3 5.99997 3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9481 19.4252C20.9505 17.514 20.9602 15.6028 20.9447 13.6917C20.9379 12.8546 20.9078 12.0153 20.7319 11.1914C20.4435 9.84065 19.7945 8.78605 18.5054 8.29429C17.6453 7.96624 16.7461 7.94512 15.848 8.07229C15.0935 8.17912 14.3985 8.46649 13.7653 9.00065C13.7653 8.80631 13.7647 8.67743 13.7655 8.5487C13.7674 8.25961 13.6329 8.12894 13.3557 8.13026C12.3708 8.13486 11.3859 8.13369 10.4008 8.13104C10.1297 8.13026 9.99963 8.24224 10 8.54699C10.0052 12.2144 10.0033 15.8818 10.0034 19.5492C10.0034 19.6898 9.98491 19.8395 10.1477 19.9087C10.1649 19.9314 13.7208 19.9399 13.7207 19.9168C13.9539 19.812 13.8822 19.5909 13.8826 19.4109C13.8858 17.6021 13.875 15.7932 13.8847 13.9844C13.8877 13.4188 13.9086 12.8474 14.1529 12.3207C14.4424 11.6966 15.0415 11.4262 15.8854 11.5369C16.4659 11.6129 16.8365 12.006 16.9519 12.6909C16.9946 12.9439 17.0265 13.2026 17.028 13.4589C17.0393 15.4485 17.0409 17.4382 17.0491 19.4279C17.05 19.6116 16.9948 19.8285 17.2315 19.9209C17.2234 19.947 20.8039 19.9312 20.8048 19.9059C20.9975 19.7936 20.9479 19.5977 20.9481 19.4252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.013fa665c4e0517dd11696814f80f579.svg";
export { ForwardRef as ReactComponent };